import {
  SimilarityFeature,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  calculateSimilarityScore,
  schSimilarityFeatures,
} from '@aloft/toolkit-shared';

import { CompSelectionProperty } from '../../types.ts';
import { similarityFeatureDefs, similarityFeatureMapping } from './features.ts';

/** @deprecated Use {@link calculateSimilarityScore} instead */
export const calcSimilarity = (
  subject: CompSelectionProperty,
  comp: CompSelectionProperty,
): number => {
  const distance = (key: SimilarityFeature): number => {
    const f = similarityFeatureMapping[key];
    let d = 1 - Math.abs((f(subject) ?? 0) - (f(comp) ?? 0)) / similarityFeatureDefs[key].maxRange;
    d = Math.max(0, Math.min(1, d)); // Clamp the value of d between 0 and 1
    // if either subject or comp is missing the value, we treat this feature as having a distance of 0
    return Number.isFinite(d) ? d : 0;
  };

  const totalDistance = schSimilarityFeatures.options
    .map((k) => similarityFeatureDefs[k].weight * distance(k))
    .reduce((a, b) => a + b, 0);

  return totalDistance;
};
